export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Атауы: "])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сақтау"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Артқа"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Активке жаңа атау беріңіз"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Бұл атау сізге активтер тізімінде әмиянды оңай анықтауға көмектеседі."])}
}